import React from "react";
import { Alert, AlertIcon, Box, Button, Spinner, Text, Tooltip, VStack } from "@chakra-ui/react";
import { useQuery } from "@apollo/client";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { usePageTitle } from "../../hooks/useDocumentTitle";
import type { Query } from "../../generated/graphql";
import ShelvShell from "../shelv/components/ShelvShell";
import { GET_PERSONAL_PROFILE } from "./queries";

export default function ViewProfile() {
  usePageTitle("Personal information");
  const { user, loading: authLoading, isAuthenticated } = useAuth();
  const { data, loading, error, refetch } = useQuery<Pick<Query, "client">>(GET_PERSONAL_PROFILE, {
    variables: { id: user?.id },
    skip: !user?.id,
  });
  if (!authLoading && !isAuthenticated) return <Navigate to="/login" state={{ from: { pathname: "/profile" } }} replace />;
  const client = data?.client;
  const name = [client?.fName, client?.lName].filter(Boolean).join(" ");
  return <ShelvShell>
    <section className="shelv-personal" aria-labelledby="personal-title">
      <h1 id="personal-title">Personal information</h1>
      <p className="shelv-personal-intro">Your details on Shelv.</p>
      {authLoading || loading ? <VStack py={12} role="status"><Spinner /><Text>Loading your details…</Text></VStack> : error || !client ?
        <Alert status="error" borderRadius="16px"><AlertIcon /><Box><Text>We couldn’t load your details.</Text><Tooltip label="Retry loading your personal information"><Button mt={3} onClick={() => void refetch()}>Try again</Button></Tooltip></Box></Alert> :
        <div className="shelv-personal-card">
          <div className="shelv-personal-avatar">
            {client.profilePhoto ? <img src={client.profilePhoto} alt={name ? `${name}'s profile` : "Profile"} width={72} height={72} /> : <span aria-hidden="true">{client.fName?.[0]?.toUpperCase() || client.email?.[0]?.toUpperCase() || "S"}</span>}
          </div>
          <dl>
            <div><dt>Name</dt><dd>{name || "Not provided"}</dd></div>
            <div><dt>Email</dt><dd>{client.email || "Not provided"}</dd></div>
            <div><dt>Phone</dt><dd>{client.phoneNumber || "Not provided"}</dd></div>
          </dl>
        </div>}
    </section>
  </ShelvShell>;
}
